import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

class WidgetsPreview extends React.Component {
    shouldComponentUpdate = (nextProps, nextState) => {
        return nextProps.widgets.length !== this.props.widgets.length;
    };

    render() {
        const { theme, widgets, token, client, user } = this.props;
        return (
            <div className="rlz-theme-customizer__widgets">
                {widgets.map((w, i) => {
                    const demoProps = {};
                    if (w.spec && w.spec.demo && w.spec.demo[0] && w.spec.demo[0].props) {
                        const props = w.spec.demo[0].props;
                        Object.keys(props).forEach(key => {
                            const wkey = 'data-' + _.kebabCase(key);
                            demoProps[wkey] = props[key];
                        });
                    }
                    return (
                        <div className="rlz-theme-customizer__widget" key={w.id + '_2'}>
                            <rlz-widget
                                data-name={w.id}
                                data-load="js"
                                data-token={token}
                                data-theme={theme}
                                data-client={client}
                                data-user={user}
                                data-ga={false}
                                data-lang="en"
                                {...demoProps}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default WidgetsPreview;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/common/WidgetsPreview.js
 **/